var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styles from './DocumentCategoryHint.module.scss';
import { Tooltip } from 'devextreme-react';
import { FaExclamation } from 'react-icons/fa';
export var DocumentCategoryHint = /** @class */ (function (_super) {
    __extends(DocumentCategoryHint, _super);
    function DocumentCategoryHint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isTooltipVisible = false;
        return _this;
    }
    DocumentCategoryHint.prototype.render = function () {
        var _a;
        var _this = this;
        var isValid = (_a = this.props, _a.isValid), id = _a.id;
        if (isValid)
            return null;
        var tooltipId = 'tooltip' + id;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { onMouseEnter: function () { return (_this._isTooltipVisible = true); }, onMouseLeave: function () { return (_this._isTooltipVisible = false); }, id: tooltipId },
                React.createElement(FaExclamation, { size: 15, className: styles.icon })),
            React.createElement(Tooltip, { visible: this._isTooltipVisible, target: "#".concat(tooltipId) },
                React.createElement("div", { className: styles.validationInfoWrapper }, "No Categories are configured to be used in the Project"))));
    };
    __decorate([
        observable
    ], DocumentCategoryHint.prototype, "_isTooltipVisible", void 0);
    DocumentCategoryHint = __decorate([
        observer
    ], DocumentCategoryHint);
    return DocumentCategoryHint;
}(React.PureComponent));
